import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Doing nothing is the hardest thing ever",
  "description": "",
  "published": "2010-10-04T00:00:00.000Z",
  "redirect_from": ["/blog/doing-nothing-is-the-hardest-thing-ever/swizec/1464"],
  "categories": "App Store, Application programming interface, IPad, Programming, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/File:IPad-02.jpg"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/10/300px-IPad-02.jpg",
              "alt": "Behold the iPad in All Its Glory",
              "title": "Behold the iPad in All Its Glory"
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/File:IPad-02.jpg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`Here's the situation: at my startup (`}<a parentName="p" {...{
        "href": "http://preona.net/"
      }}>{`Preona`}</a>{`) we're pushing to submit the final-ish version of `}<a parentName="p" {...{
        "href": "http://lazyreadr.com/"
      }}>{`LazyReadr`}</a>{` to the `}<a parentName="p" {...{
        "href": "http://www.apple.com/iphone/appstore",
        "title": "App Store"
      }}>{`App Store`}</a>{`. We thought we'd be finished last Friday. Then we thought we'd manage to finish by Sunday. Now we believe we'll have a reasonably crossed-out TODO list on the whiteboard by Wednesday or thereabouts.`}</p>
    <p>{`This isn't a desirable situation, but in a team of three, it happens. A nasty bug pops up and suddenly the only man in charge of a certain piece of the project is battling for a whole day and doesn't manage to get as much done as he'd hoped.`}</p>
    <p>{`And there's nothing the other two can do. That's the horrible part.`}</p>
    <p>{`We have a designer who also does some css/html. We have a backend guy who does python and weird `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Computer_data_processing",
        "title": "Computer data processing"
      }}>{`data processing`}</a>{`. And we have a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Front_and_back_ends",
        "title": "Front and back ends"
      }}>{`frontend`}</a>{` guy who does the `}<a parentName="p" {...{
        "href": "http://www.apple.com/ipad/",
        "title": "iPad"
      }}>{`iPad`}</a>{` development. Each of us is the best in his segment and anyone else on the team trying to help, or do his work, would just get in the way and take longer to do it.`}</p>
    <p>{`Right now the bottleneck is the frontend. There are still two days of work left on the frontend ... and there's nothing I can do. It's really horrible, there is a problem with `}<em parentName="p">{`my`}</em>{` product. And I can't help. The best thing I can do is to stay at home for two days so as to not lure the frontend guy into the temptation of being social and chatty.`}</p>
    <p>{`I'm sure every CEO reaches this point some time in their lifetime. But it's just so horrible. I know he can handle it. I'm sure everything will be alright. But just fiddling my thumbs and getting out of the way is `}<em parentName="p">{`hard`}</em>{`.`}</p>
    <p>{`The whole situation would be a lot easier to handle if I could just shove him out of the way, shout something like "Stop being such a buffoon! THIS is how you do it!" and coding furiously for two hours to solve all the problems he's having. But I can't, I don't know the first thing about `}<a parentName="p" {...{
        "href": "http://developer.apple.com/documentation/Cocoa/Conceptual/ObjectiveC/",
        "title": "Objective-C"
      }}>{`Objective C`}</a>{` or how the iPad's `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Application_programming_interface",
        "title": "Application programming interface"
      }}>{`API`}</a>{` works.`}</p>
    <p>{`Hell, last night I stayed up until 6am rewriting a piece of the backend functionality just to feel productive. It doesn't do anything in reaching this deadline. The whole backend is sufficiently decoupled from the frontend so I could easily do this in a few weeks and users wouldn't notice the difference.`}</p>
    <p>{`But I `}<em parentName="p">{`can't do nothing!`}</em>{` I never thought I'd say something like this but `}<strong parentName="p">{`doing nothing is the hardest thing I ever did.`}</strong></p>
    <h6 {...{
      "id": "related-articles-by-zemanta"
    }}>{`Related articles by Zemanta`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://news.ycombinator.com/item?id=1565206"
        }}>{`Ask HN: If you could start from scratch, would you still use LAMP?`}</a>{` (news.ycombinator.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://torrentfreak.com/shocking-apple-approves-bittorrent-app-for-iphone-app-store-101002/"
        }}>{`Shocking: Apple Approves BitTorrent App For App Store`}</a>{` (torrentfreak.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=ec563f18-b383-4404-9831-5d607344b642",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      